export const getSubdomain = () => {
  const fullURL = window.location.host.split('.')
  const subdomain = fullURL[0]
  return subdomain
}
